/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { PlannedOutageDetailService } from '../services/planned-outagesdetail.service';
import { ActivatedRoute } from '@angular/router';
import { PlannedOutagesDetailResponse } from '../model/planned-outagesdetailresponse';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { HttpClient } from '@angular/common/http';
import { CustomerPreferenceService } from '../../../../customer/preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../customer/preference/customerpreference.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'zsd-planned-outagesdetail',
    templateUrl: '../view/planned-outagesdetail.component.html',
    styleUrls: ['../view/planned-outagesdetail.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PlannedOutagesDetailComponent implements OnInit {
    showReason = true;
    plannedOutageDetailResponse: PlannedOutagesDetailResponse;
    itemsResultsCount = 0;
    plannedOutageId: number;
    itemDataFound: boolean;
    changeRequestDataFound: boolean;
    noRecords: string;
    showMore = true;
    progress = false;
    show = false;
    isCollapsed = true;
    content: string;
    currentText: string;
    maxLength = 250;
    canViewCustomers: boolean;
    canViewChangeRequest: boolean;

    constructor(private plannedOutageDetail: PlannedOutageDetailService, private route: ActivatedRoute,
        public _DomSanitizer: DomSanitizer, public zsdTranslate: ZSDTranslateService,
        private custpreferences: CustomerPreferenceService, public http: HttpClient) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.plannedOutageId = params['plannedOutageId'];
        });
        this.custpreferences.getPreferenceList().toPromise()
            .then(
                (customerpreferenceResponse: CustomerPreferenceResponse) => {
                    this.canViewCustomers = customerpreferenceResponse.showAffectedUsersForPlannedOutages;
                    this.canViewChangeRequest = customerpreferenceResponse.showChangeRequestForPlannedOutages;
                    this.initializeData();
                }
            );
    }

    determineView() {
        if (this.plannedOutageDetailResponse.reason.length <= this.maxLength) {
            this.isCollapsed = false;
            return;
        }
        if (this.isCollapsed === true) {
            this.currentText = this.plannedOutageDetailResponse.reason.substring(0, this.maxLength);
        } else if (this.isCollapsed === false) {
            this.currentText = this.plannedOutageDetailResponse.reason;
        }
    }
    toggleView() {
        if (!this.isCollapsed) {
            window.scrollTo(0, 0);
        }
        this.isCollapsed = !this.isCollapsed;
        this.determineView();
    }
    initializeData() {
        this.plannedOutageDetail.getPlannedOutageDetail(this.plannedOutageId)
            .subscribe(resp => {
                this.plannedOutageDetailResponse = resp;
                if (this.plannedOutageDetailResponse.plannedOutageItems) {
                    this.itemDataFound = resp.plannedOutageItems.length > 0;
                }
                if (this.plannedOutageDetailResponse.plannedOutageChangeRequestsInfo) {
                    this.changeRequestDataFound = resp.plannedOutageChangeRequestsInfo.length > 0;
                }
                if (!this.changeRequestDataFound) {
                    this.noResultsFound();
                }
                if (this.plannedOutageDetailResponse.reason) {
                    this.currentText = this.plannedOutageDetailResponse.reason;
                    this.determineView();
                }
                this.initializePlannedOutageDetailDataTable();
            },
                err => {
                    this.progress = false;
                    console.log(err);
                    this.itemDataFound = false;
                    this.plannedOutageDetailResponse = null;
                }
            );
    }

    initializePlannedOutageDetailDataTable() {
        $('#changeRequestList').DataTable({
            'paging': false,
            'searching': false,
            'processing': true,
            'info': false,
            data: this.plannedOutageDetailResponse.plannedOutageChangeRequestsInfo,
            columns: [
                { data: 'requestId' },
                { data: 'technicianName' },
                { data: 'requestTeam' },
                { data: 'requestStatus' },
                { data: 'description' },
            ],
            'columnDefs': [{
                'targets': 4,
                'orderable': false
            }]
        });
        let itemList = $('#itemList').DataTable({
            'paging': false,
            'searching': false,
            'processing': true,
            'info': false,
            data: this.plannedOutageDetailResponse.plannedOutageItems,
            columns: [
                { data: 'itemNumber' },
                { data: 'itemTypeName' },
                { data: 'itemCategoryName' },
                // hide customers and orgUnit when canViewCustomers is false
                { data: 'customers', 'render': function(data) {
                    let dataString = '';
                    if (data) {
                        dataString = data.toString();
                    }
                    return dataString.split(',').join('<br/>');
                }},
                { data: 'orgUnit' },
            ],
            'columnDefs': [{
                'targets': 3,
                'orderable': false
            },
            {
                'targets': 4,
                'width': '15%',
                'orderable': false
            }]
        });
        if (!this.canViewCustomers) {
            itemList.columns([3, 4]).visible(false);
        }
        this.progress = true;
    }
    noResultsFound() {
        return this.noRecords = 'DataTableList.noRecords';
    }
}
